// DPIA acțiunea A3 / B1 — proveniența unui import, partea pură.
//
// Regula de produs, decisă de owner la 2026-08-27: răspunsul este obligatoriu de
// dat, dar `undocumented` este un răspuns valid. Operatorul este forțat să vadă
// întrebarea, nu să răspundă într-un anume fel; importul nu se blochează
// niciodată din acest motiv (DPR-086). De aceea nu există valoare preselectată —
// un default ar însemna un răspuns pe care nimeni nu l-a dat.
//
// Oglindă a `backend/ncrm/import/provenance.js`. Cele două liste trebuie să
// rămână identice; un test de regresie le compară.
export const SOURCE_CATEGORIES = Object.freeze([
  "purchased_list",
  "event",
  "public_source",
  "existing_relationship",
  "own_collection",
  "other",
  "undocumented",
]);

// Categoriile în care datele nu vin de la persoana vizată, deci informarea este
// datorată. `existing_relationship` și `own_collection` sunt colectări directe
// sau contexte în care informarea a avut deja loc; `undocumented` intră în listă
// tocmai pentru că nu putem presupune contrariul.
export const INDIRECT_COLLECTION_CATEGORIES = Object.freeze([
  "purchased_list",
  "event",
  "public_source",
  "other",
  "undocumented",
]);

export const createEmptyProvenance = () => ({
  sourceCategory: null,
  sourceDescription: "",
  subjectsAlreadyInformed: false,
});

// `other` fără descriere este un răspuns gol: singurul lucru care face categoria
// utilă peste doi ani este textul care o explică.
export const isProvenanceComplete = (provenance) => {
  const category = provenance?.sourceCategory;
  if (!SOURCE_CATEGORIES.includes(category)) return false;
  if (category !== "other") return true;
  return Boolean(String(provenance?.sourceDescription || "").trim());
};

export const requiresSubjectInformation = (provenance) => {
  if (provenance?.subjectsAlreadyInformed) return false;
  return INDIRECT_COLLECTION_CATEGORIES.includes(provenance?.sourceCategory);
};
